import { DATE_FORMATS } from "~/utils/constants";
import { toStandardFormat } from "~/utils/datetime";
import { generateGpMainUrl } from "~/utils/url";

export const generateDataMapsUrl = (arenaSecondLevelDomain: string): string =>
  `${generateGpMainUrl(arenaSecondLevelDomain)}/admin_settings/configuration_category/data_maps`;

export const formatDate = (date: string | null): string => {
  if (!date) return "";

  return toStandardFormat(date, DATE_FORMATS["MM/DD/YYYY"].long);
};

export const toRoundedCents = (amount: string): number => {
  const parsedAmount = Number(amount);
  return Number.isFinite(parsedAmount) ? Math.round(parsedAmount * 100) : 0;
};
